module.exports = __webpack_public_path__ + "files/tropi4.4b8c45d353518bee715a3c04692333ba.pdf";